export enum EmploymentProperty {
Worker,
Employee,
}
